import React from 'react';

export const Avatar: React.FC = () => (
  <div className="flex-shrink-0 w-8 h-8 rounded-lg overflow-hidden">
    <img src="/avatar.png" alt="CINTIA" className="w-full h-full object-cover" />
  </div>
);
